import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {SaCabinetDetailComponent} from "../cabinets/saCabinet-detail.component";
import {MatLegacySelectChange as MatSelectChange} from "@angular/material/legacy-select";

@Component({
  selector: 'micro-saLockController-detail',
  templateUrl: './saLockController-detail.component.html'
})
export class SaLockControllerDetailComponent implements OnInit {

  @Input()
  lockId:any;

  controller:any;
  disableSerial:boolean;
  defaultParamSetsByLockNumber:any = {};
  defaultParamSets:any = {};
  defaultParamSetsLoaded:boolean = false;
  controllerOpenAccessRequestCount = 0;
  // lockDefaultParamSetOptions:any[] = [];
  // lockDefaultParamSetSelected;

  @ViewChild(SaCabinetDetailComponent, {static: false}) saCabinetDetailComponent: SaCabinetDetailComponent;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    if (this.lockId) {
      this.loadId(this.lockId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id === '0') {
            this.createNew();
          } else {
            this.loadId(id);
          }
        });
    }

    this.http.get(`${this.env.e.url}/access/saLocks/lockDefaultParamSets`).subscribe(
      data => {
        let paramSetList = data as any[];
        for (const paramSetListElement of paramSetList) {
          let set = this.defaultParamSets[paramSetListElement.lockType];
          if (set === undefined) {
            set = [];
            this.defaultParamSets[paramSetListElement.lockType] = set;
          }
          set.push(paramSetListElement);
        }
        this.defaultParamSetsLoaded = true;
        this.setupLocksParamSets();
      }
    );

  }

  disableSerialRule() {
    return (!!this.controller.id && !!this.controller.serialNumber) || !this.authService.hasRole('SITE_LOCK_COMPANY');
  }

  loadId(id) {
    this.http.get(`${this.env.e.url}/access/saLocks/controllers/${id}`).subscribe(
      data => {
        this.setController(data);
      }
    );
  }

  setController(controller:any) {
    this.controller = controller;
    for (const lock of controller.locks) {
      this.controllerOpenAccessRequestCount += lock.openAccessRequestCount;
      if ((lock.type == 'Servo' || lock.type == 'ServoDelayed' || lock.type == 'ServoEagle') && !lock.lockParam.model) {
        lock.lockParam.model = "*";
      }
    }

    this.disableSerial = this.disableSerialRule();
    this.setupLocksParamSets();
  }

  createNew() {
    this.controller = {
      companyId: this.authService.getCompanyId(),
      status: 'REGISTERED',
      validityPeriod: 2,
      locks: [
        {
          lockNumber: 0,
          description: undefined,
          type: 'Pulse',
          lockParam: {
            paramType: 'NONE'
          }
        }
      ]
    };
    this.disableSerial = this.disableSerialRule();
    this.controllerOpenAccessRequestCount = 0;
  }

  save() {
    if (!this.controller.id) {
      this.http.post(`${this.env.e.url}/access/saLocks/controllers`, this.controller)
        .subscribe(
          data => {
            this.setController(data);
            if (this.saCabinetDetailComponent) {
              this.saCabinetDetailComponent.reload();
            }
            this.alertService.info(`Created ${this.controller.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/access/saLocks/controllers/${this.controller.id}`, this.controller)
        .subscribe(
          data => {
            this.setController(data);
            if (this.saCabinetDetailComponent) {
              this.saCabinetDetailComponent.reload();
            }
            this.alertService.info(`Updated ${this.controller.name}`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/access/saLocks/controllers/${this.controller.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.controller.name}`);
          this.router.navigate(["/saLocks/controllers`"]);
        }
      );
  }

  typeChange(lock) {
    switch (lock.type) {
      case 'Servo':
        lock.lockParam = {
          angle: undefined,
          angleMin: undefined,
          angleMax: undefined,
          pwmMin: undefined,
          pwmMax: undefined,
          model: "*",
          paramType: 'SERVO',
        }
        break;
      case 'ServoDelayed':
        lock.lockParam = {
          angle: undefined,
          angleMin: undefined,
          angleMax: undefined,
          pwmMin: undefined,
          pwmMax: undefined,
          model: "*",
          paramType: 'SERVO-DELAY',
        }
        break;
      case 'ServoEagle':
        lock.lockParam = {
          angle: undefined,
          angleMin: undefined,
          angleMax: undefined,
          pwmMin: undefined,
          pwmMax: undefined,
          model: "*",
          paramType: 'SERVO-EAGLE',
        }
        break;
      default:
        lock.lockParam = {
          paramType: 'NONE',
        }
        break;
    }
    this.setupParamSets(lock);
  }

  setupLocksParamSets() {
    if (this.defaultParamSetsLoaded && this.controller) {
      for (const lock of this.controller.locks) {
        this.setupParamSets(lock);
      }
    }
  }

  setupParamSets(lock:any) {
    let lockDefaultParamSet = this.defaultParamSetsByLockNumber[lock.lockNumber];
    if (!lockDefaultParamSet) {
      lockDefaultParamSet = {};
      this.defaultParamSetsByLockNumber[lock.lockNumber] = lockDefaultParamSet;
    }
    lockDefaultParamSet.options = [];
    var lockType = lock.type?.startsWith("Servo") ? "Servo" : lock.type;
    let lockTypeSets = this.defaultParamSets[lockType];
    lockDefaultParamSet.selected = undefined;
    switch (lockType) {
      case 'Servo':
        lockDefaultParamSet.options.push({
          id: 'CUSTOM',
          name: 'Custom Servo',
          paramType: 'Servo',
          params: {
            angle: undefined,
            angleMin: undefined,
            angleMax: undefined,
            pwmMin: undefined,
            pwmMax: undefined,
            model: "*"
          }
        });
        for (const set of lockTypeSets) {
          lockDefaultParamSet.options.push(set);
          if (!lockDefaultParamSet.selected
            && lock.lockParam.angle === set.params['angle']
            && lock.lockParam.angleMin === set.params['angleMin']
            && lock.lockParam.angleMax === set.params['angleMax']
            && lock.lockParam.pwmMin === set.params['pwmMin']
            && lock.lockParam.pwmMax === set.params['pwmMax']
            && (lock.lockParam.model === set.params['model']
              || (lock.lockParam.mode = "*" && !set.params['model']))) {
            lockDefaultParamSet.selected = set;
          }
        }
        if (!lockDefaultParamSet.selected && (
          lock.lockParam.angle
          || lock.lockParam.angleMin
          || lock.lockParam.angleMax
          || lock.lockParam.pwmMin
          || lock.lockParam.pwmMax
          || lock.lockParam.model !== "*"
        )) lockDefaultParamSet.selected = lockDefaultParamSet.options[0];
        break;
    }
  }

  csvToLines(csv: string) {
    if (csv) return csv.replace(/\s*,\s*/g, "\n");
    return "";
  }

  getFirmwareConfigObj(controller: any) {
    if (controller.firmwareConfig && !controller.firmwareConfigObj) {
      try {
        controller.firmwareConfigObj = JSON.parse(controller.firmwareConfig);
      } catch (e) {
        controller.firmwareConfigObj = {};
      }
    }
    return controller.firmwareConfigObj;
  }
}
